module.exports = __webpack_public_path__ + "static/media/1f6eb.41b45618.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f6eb.svg
// module id = 638
// module chunks = 1